import React, {useEffect, useState} from "react";
import {GameMode} from "../../../models/GameMode";
import {Link} from "react-router-dom";
import {GameApi} from "../../../services/api/GameApi";

type typeGameMode = {
    gameMode: GameMode
}

export const CardChooseGameMode: React.FC<typeGameMode> = (props) => {
    const [gameThemeName, setGameThemeName] = useState<string>("");

    useEffect(() => {
        if (props.gameMode.idGameTheme === null) return;
        GameApi.getGameThemesNameById(props.gameMode.idGameTheme).then((data) => {
            setGameThemeName(data)
        });
    }, []);

    return (
        <Link to={"/" + gameThemeName + "/" + props.gameMode.name!!.split(" ")[0]}
               state={{gameModeId: props.gameMode.id}}
              >
            <div>
                <div className="flex flex-col gap-12 bg-deep-blue border-2 border-darkpurple-blue rounded-2xl p-3 hover:scale-105">
                    <div>
                        <h3 className="text-2xl mb-4">{props.gameMode.name}</h3>
                        <p>{props.gameMode.description}</p>
                    </div>
                </div>
            </div>
        </Link>
    )
}
